import { useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { GroupTraining } from 'entities/group_training'
import { A4 } from 'components/shared/print'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const GroupTrainingLedgerPage = (props: Props) => {
    return (
        <>
            <ContentHeader
                className="no-print"
                headerTitle="集合教育記録台帳"
                right={
                    <>
                        <Button
                            onClick={() => {
                                window.print()
                            }}
                        >
                            印刷プレビュー
                        </Button>
                        <Button variant="secondary" onClick={() => props.history.push('/ledger/group_training')}>
                            講習会一覧へ戻る
                        </Button>
                    </>
                }
            />
            <GroupTrainingLedgerPaper groupTraining={(props.history.location.state as Record<string, any>)?.groupTraining} />
        </>
    )
}

export default withRouter(GroupTrainingLedgerPage)

type GroupTrainingLedgerPaperProps = {
    groupTraining?: GroupTraining
}

const GroupTrainingLedgerPaper = (props: GroupTrainingLedgerPaperProps) => {
    const row = 12
    const page: number = useMemo(() => {
        return Math.ceil(Math.max((props.groupTraining?.groupTrainingTrainees?.length ?? 0) / row, 1))
    }, [props.groupTraining])

    return (
        <>
            {new Array(page).fill(0).map((_, i) => {
                return (
                    <A4 key={`group-training-ledger-${i}`} padding={0} landscape={false} style={{ padding: 0 }}>
                        <div className={'preview-result'} style={{ left: 30, padding: '20px 50px' }}>
                            <Flex justifyContent="space-between" style={{ marginBottom: 5, paddingBottom: 20 }}>
                                <div style={{ fontSize: 10 }}>
                                    <div>Form10.02 集合教育記録台帳</div>
                                    <div>ver1: 2021/01/05</div>
                                </div>
                                <div style={{ textAlign: 'right', fontSize: 10 }}>{`Page: ${1 + i} / ${page}`}</div>
                            </Flex>
                            <div style={{ fontSize: 20, textAlign: 'center' }}>集合教育記録台帳</div>
                            <div
                                style={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', marginBottom: 20 }}
                            >{`講習名：「${props.groupTraining?.sessionName}」`}</div>
                            <Flex justifyContent="flex-end" style={{ marginBottom: 20 }}>
                                <div>
                                    <div style={{ fontSize: 15, textAlign: 'right' }}>{`トレーナー：${props.groupTraining?.trainer?.fullName}`}</div>
                                    <div style={{ fontSize: 15, textAlign: 'right' }}>{`日付: ${props.groupTraining?.date}`}</div>
                                </div>
                            </Flex>
                            <div style={{ width: '100%', fontSize: 15 }}>
                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <tr>
                                        <td style={{ fontWeight: 'bold' }}>受講者一覧</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: 'solid 1px' }}>氏名</td>
                                        <td style={{ border: 'solid 1px' }}>日付</td>
                                        <td style={{ border: 'solid 1px' }}>効果測定（アンケート）</td>
                                    </tr>
                                    {new Array(row).fill(0).map((_, j) => {
                                        const t = (props.groupTraining?.groupTrainingTrainees ?? [])[i * row + j]
                                        if (t) {
                                            return (
                                                <tr key={`group-training-trainee-${j}`}>
                                                    <td style={{ border: 'solid 1px' }}>{t.trainee?.fullName}</td>
                                                    <td style={{ border: 'solid 1px' }}>{t.date}</td>
                                                    <td style={{ border: 'solid 1px' }}>
                                                        <Flex flexDirection="column" className="">
                                                            <Flex style={{ marginTop: 5, marginBottom: 0, marginLeft: 5 }} alignItems={'center'}>
                                                                <input type="checkbox" key="1" checked={t.isOk} />
                                                                <div>よく理解できた</div>
                                                            </Flex>
                                                            <Flex style={{ margin: 5 }} alignItems={'center'}>
                                                                <input type="checkbox" key="1" checked={!t.isOk} />
                                                                <div>理解できなかったので再履修希望</div>
                                                            </Flex>
                                                        </Flex>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })}
                                </table>
                            </div>
                        </div>
                    </A4>
                )
            })}
        </>
    )
}
